/******************************** Import Package ************************************/
import React from "react";
import { FormControl, FormControlLabel, Checkbox as MuiCheckbox } from "@mui/material";

/******************************** Check Box  ************************************/
export default function Checkbox(props) {
  const { name, label, value, onChange } = props;

  const convertToDefEventPara = (name, value) => ({
    target: {
      name,
      value,
    },
  });

  return (
    <FormControl>
      <FormControlLabel
        control={
          <MuiCheckbox
            name={name}
            sx={{ color: "#4e9a98" }}  // ✅ in v5 we prefer sx instead of inline style
            checked={value}
            onChange={(e) =>
              onChange(convertToDefEventPara(name, e.target.checked))
            }
          />
        }
        label={label}
      />
    </FormControl>
  );
}
